import React from 'react';
import Configurator from './Configurator.jsx';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';
import CheckboxList from './ui/CheckboxList.jsx';
import MyStlViewer from './ui/MyStlViewer.jsx';
import styles from './ElectTechClosetConfigurator.styl';

/**
 * Конфигуратор металлических оболочек
 */
class ElectTechClosetConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);

		this.db = null;
		this.filter = {};

		this.state = {
			filters: {},
			articles: [],
			item: null,
			view3d: false
		};

		this.on3DDownload = this.on3DDownload.bind(this);
		this.onToggleView3D = this.onToggleView3D.bind(this);
		this.onDownloadInstruction = this.onDownloadInstruction.bind(this);
	}

	getType() {
		return 'electTechCloset';
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator(this.state);
		}
	}

	onDwgDownload(item) {
		if (!item || !item.dwg) {
			return;
		}
		window.location = `itkcfg.php?type=${this.getType()}&action=getDwg&article=${item.article}`;
	}
	onDownloadInstruction(item) {
		if (!item || !item.instruction) {
			return;
		}
		window.location = `itkcfg.php?action=getFileZip&type=${this.getType()}&name=instruction&article=${item.instruction}`;
	}

	on3DDownload() {
		window.location = `itkcfg.php?type=${this.getType()}&action=getFile&name=3d.zip`;
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<Button
				x="719"
				y="627"
				buttonStyle={styles.mainBtnInstruction}
				buttonDisabledStyle={styles.mainBtnInstructionDisabled}
				textStyle={styles.mainBtnTextInstruction}
				iconStyle={styles.pdfBtnIconInstruction}
				text="Инструкция по монтажу"
				disabled={!this.state.item || !this.state.item.instruction}
				onClick={() =>this.onDownloadInstruction(this.state.item)}
				key="instructionPdf"
			/>
		);

		elements.push(
			<Button
				x="539"
				y="627"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIconInstruction}
				text="В корзину"
				disabled={!this.state.item}
				onClick={() => this.onBtnCartClick()}
				key="addToCart"
			/>
		);

		elements.push(
			<Button
				x="34"
				y="675"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				disabled={!this.state.item}
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="230"
				y="675"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				disabled={!this.state.item}
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="423"
				y="675"
				buttonStyle={styles.stepBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.stepBtnIcon}
				text="Скачать 3D-модели"
				onClick={this.on3DDownload}
				key="step"
			/>
		);

		elements.push(
			<Button
				x="615"
				y="675"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.dwgBtnIcon}
				text="Скачать чертеж dwg"
				disabled={!this.state.item || !this.state.item.dwg}
				onClick={()=>this.onDwgDownload(this.state.item)}
				key="dwg"
			/>
		);

		elements.push(
			<Button
				x="808"
				y="675"
				buttonStyle={styles.mainBtn}
				buttonDisabledStyle={styles.mainBtnDisabled}
				textStyle={styles.mainBtnText}
				iconStyle={styles.accessoryBtnIcon}
				text="Перейти к подбору аксессуаров"
				disabled={!this.state.item || !this.state.item.has_acc}
				title={this.state.item && !this.state.item.has_acc ? 'Нет аксессуаров к выбранному шкафу.' : null}
				onClick={this.onSwitchConfigurator}
				key="swconf"
			/>
		);

		return elements;
	}

	getCustomStyles() {
		return styles;
	}

	getFilterTitles() {
		return {
			'color': 'По желанию заказчика возможно нанесения покрытия любого цвета'
		};
	}

	onFilterChange(prop, value) {
		if ('series' === prop) {
			this.filter = {};
		}
		super.onFilterChange(prop, value);
	}

	onToggleView3D() {
		this.setState(prevState => {
			return {
				view3d: !prevState.view3d
			};
		});
	}

	render() {
		const customStyles = this.getCustomStyles();

		if (!this.db) {
			return <div className={customStyles.cfg} />;
		}

		const items = this.applyFilters()

		const abbreviation = items.map(item => {
			return {article:item.article, abbreviation:item.abbreviation};
		});

		return (

			<div className={customStyles.cfg}>
				{/*Logo*/}
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>

				<span className={styles.title}>Конфигуратор металлических оболочек</span>

				{this.getCustomElements ? this.getCustomElements() : null}

				{this.buildDropdownFilters()}

				<span className={styles.abbreviation}>Наименование</span>

				{/* Список артикулов аксессуаров */}
				<CheckboxList
					className={styles.list}
					items={this.state.articles}
					abbreviation={abbreviation}
					selectedValue={this.state.item ? this.state.item.article : null}
					onItemCheck={this.onListItemCheck}
				/>
				{/* Артикул и название */}
				{this.state.item ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item.article}`} target="_blank">
						<div className={styles.name}>
							<div><strong>{this.state.item.name}</strong></div>
							<div><strong>{this.state.item.article}</strong></div>
							<div className={styles.nameDimension}>ВхШхГ: {`${this.state.item.dimension_height}`}x{`${this.state.item.dimension_width}`}x{`${this.state.item.dimension_depth}`}
							</div>
						</div>
					</a>
				) : (
					<div className={styles.nameEmpty} />
				)}

				{/* Изображение */}
				<Image
					className={styles.img}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
				/>

				{this.state.item && this.state.item.model3d && this.state.view3d &&
					<MyStlViewer
						className={styles.stlViewer}
						url={`itkcfg.php?type=${this.getType()}&action=getDwg&article=${encodeURI(this.state.item.model3d)}`}
						width={450}
						height={284}
						modelColor='#909090'
						backgroundColor='#FFFFFF'
						rotate={true}
						orbitControls={true}
						lights={[]}
						rotationSpeeds={[0.02, 0.02, 0.02]}
						key={this.state.item.article}
					/>
				}

				{this.state.item && this.state.item.model3d &&
					<div className={styles.stlViewerToggle} onClick={this.onToggleView3D}>
						<span>Открыть {this.state.view3d ? 'фотографию' : '3D-модель'}</span>
					</div>
				}

				{/* Описание */}
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>{this.state.item.description}</div>
				) : (
					<div className={styles.descriptionEmpty} />
				)}

				{/* На основной сайт IEK */}

				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '723px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '723px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '726px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>

		);
	}
}

export default ElectTechClosetConfigurator;



// WEBPACK FOOTER //
// ./src/react/ElectTechClosetConfigurator.jsx